export default __webpack_public_path__ + "static/media/schoolAddImg5 - Copy.a9d37bd8.png";